export const exchangeValidation = {
    mandatory,
  }
  function mandatory(exchange) {
    const errors = {}
    if (!exchange.name) {
      errors.name = 'Exchange Name is required'
    }
    return errors
}